<template>
  <div
    class="Budgets-col col-12 col-md-6 col-lg-4 col-xl-3 pb-3"
    @click="checkDetail"
  >
    <div class="Budgets-itm d-flex flex-column space-between p-3 w-100 mb-3">
      <div class="Budgets-itmHeader d-flex justify-content-between">
        <div
          class="Budgets-th ellipsis"
          v-tooltip="budgetName"
        ><span class="Budgets-type">{{budgetName}}</span> <span
            class="Budgets-role"
            v-t="{path: 'budgets_budget_owner'}"
            v-if="isCurrentUserBudgetOwner"
          ></span></div>
        <div class="Budgets-td d-flex flex-column text-right"><span>{{$t(`budgets_budget_type__${budgetCycleType}`)}}</span>
          <span :class="budgetExpirationClass">
            {{budgetExpirationRenderLabel}}
          </span>
        </div>
      </div>
      <div class="Bugdets-itmBody d-flex justify-content-between">
        <div
          class="Budgets-th Budget-th--black Budgets-th--dot"
          v-t="{path : 'budgets_budget_goal_limit'}"
        ></div>
        <div
          class="Budgets-th Budgets-th--black ellipsis"
          v-tooltip="budgetGoal"
        >{{budgetGoal}}</div>
      </div>
      <div class="Bugdets-itmBody d-flex justify-content-between">
        <div
          class="Budgets-td Budgets-td--dot Budgets-td--dot--black"
          v-t="{path:'budgets_budget_assigned'}"
        ></div>
        <div
          class="Budgets-td ellipsis"
          v-tooltip="budgetAssigned"
        >{{budgetAssigned}}</div>
      </div>
      <div class="Bugdets-itmBody d-flex justify-content-between">
        <div
          class="Budgets-td Budgets-td--dot Budgets-td--dot--blue"
          v-t="{path: 'budgets_budget_spent'}"
        ></div>
        <div
          class="Budgets-td ellipsis"
          v-tooltip="budgetSpent"
        >{{budgetSpent}}</div>
      </div>
      <budget-progress-bar
        :goal="budget.goal"
        :assigned="budget.assigned"
        :spent="budget.spent"
        budgetCardProgressTemplate
      ></budget-progress-bar>
    </div>
  </div>
</template>

<script>
import BudgetProgressBar from './BudgetProgressBar'

export default {
  name: 'BudgetCard',
  props: {
    budget: {
      type: Object,
      required: true
    }
  },
  components: {
    BudgetProgressBar
  },
  methods: {
    checkDetail () {
      this.$router.push(`/budgets/detail/${this.budget.id}`)
    }
  },
  computed: {
    budgetName () {
      return this.budget && this.budget.name ? this.budget.name : ''
    },
    isCurrentUserBudgetOwner () {
      return this.budget && this.budget.imOwner
    },
    budgetGoal () {
      return this.budget && this.budget.goal ? this.$options.filters.currency(this.budget.goal, '€', 2, { symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ',' }) : ''
    },
    budgetCycleType () {
      return this.budget && this.budget.budgetCycle ? this.budget.budgetCycle.code : ''
    },
    budgetAssigned () {
      return this.budget ? this.$options.filters.currency(this.budget.assigned, '€', 2, { symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ',' }) : ''
    },
    budgetSpent () {
      return this.budget ? this.$options.filters.currency(this.budget.spent, '€', 2, { symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ',' }) : ''
    },
    budgetDaysToExpiration () {
      if (this.budget && this.budget.expirationDate) {
        const properExpirationDate = this.budget.expirationDate.split('T')[0]
        const expirationDate = this.$moment.utc(properExpirationDate)
        const today = this.$moment.utc().startOf('day')
        return expirationDate.diff(today, 'days')
      }
      return false
    },
    budgetExpirationRenderLabel () {
      if (this.budget && this.budget.expirationDate) {
        if (this.budgetDaysToExpiration > 0) {
          return this.$t('budgets_budget_days_to_expiration', { daysToExpire: this.budgetDaysToExpiration })
        }
        if (this.budgetDaysToExpiration === 0) {
          return this.$t('budgets_budget_day_expires_today')
        }
        if (this.budgetHasExpired) {
          return this.$t('budgets_budget_days_to_expiration_expired')
        }
      }
      return ''
    },
    budgetHasExpired () {
      const expirationDate = this.$moment.utc(this.budget.expirationDate).startOf('day')
      return this.$moment.utc().isAfter(expirationDate)
    },
    budgetCloseToExpiration () {
      return this.budgetDaysToExpiration > 0 && this.budgetDaysToExpiration <= 10
    },
    budgetExpirationClass () {
      if (this.budgetHasExpired || this.budgetDaysToExpiration === 0) {
        return 'Budgets-expire'
      }
      if (this.budgetCloseToExpiration) {
        return 'Budgets-warning'
      }
      return 'Budgets-valid'
    }

  }

}
</script>

<style scoped>
.Budgets-col {
  cursor: pointer;
}
</style>
